import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';

import moment, { Moment } from 'moment';
import { filter, Subject, takeUntil } from 'rxjs';
import { DataCollectorService } from '../../utility/data_collector.service';
import { WorkflowService } from '../../workflows/workflow.service';
import { HlmProgressIndicatorDirective } from '../../../../../../spartan_libs/ui-progress-helm/src';
import { BrnProgressComponent, BrnProgressIndicatorComponent } from '@spartan-ng/ui-progress-brain';
import { DateFormatPipe } from '../../pipes/dateFormat.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  imports: [
    CommonModule, 
    RouterModule, 
    BrnProgressComponent, 
    BrnProgressIndicatorComponent, 
    HlmProgressIndicatorDirective, 
    DateFormatPipe,
    TranslateModule
  
  ],
  standalone: true,
  providers: [DataCollectorService]
})
export class SideNavComponent implements OnInit, OnDestroy {
  currentDate: Moment = moment().endOf('month');
  totalRecords: number = 0;
  limit: number = 0;
  executionLimit: number = 0;
  totalExecutionRecords: number = 0;

  private readonly unsubscribe$: Subject<void> = new Subject();
  currentRoute: string = '/workflows';

  constructor(
    private _dataCollectorService: DataCollectorService,
    private _workflowService: WorkflowService,
    private _toast: HotToastService,
    private _router: Router,
    private _route: ActivatedRoute,
    private localisationService: LocalisationService
  ){
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentRoute = this._router.url;
    });
    this.currentRoute = this._router.url;

  }


  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.getLimit();
    this.getActiveWorkflows();
    this.getExecutionHistory();
    this.checkChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  isActive(route: string): boolean {
    return this.currentRoute.endsWith(route);
  }

  getTotalExecutionLeft(): number {
    return Math.max(this.executionLimit - this.totalExecutionRecords, 0)
  }

  checkChanges(): void {
    this._workflowService.workflowChange$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (res: any) => {
          if(res){
            this.getActiveWorkflows();
          }
        }
      })
  }

  getLimit(): void {
    let companyPolicy = localStorage.getItem('company_policy');
    // if(!companyPolicy){
    //   companyPolicy = `{"workflows" : {
    //     "history_retention_days" : 30,
    //     "is_enabled" : true,
    //     "max_count" : 10,
    //     "max_execution_mins" : 5,
    //     "max_executions_per_month" : 5000,
    //     "supported_triggers" : []
    //   }}`
    // }
    if(companyPolicy){
      const policy = JSON.parse(companyPolicy)
      if(policy?.workflows?.max_count){
        this.limit = policy.workflows.max_count;
      }
      if(policy?.workflows?.max_executions_per_month){
        this.executionLimit = policy?.workflows?.max_executions_per_month;
      }
    }
  }

  getExecutionPercentage(): number {
    if(this.executionLimit && this.totalExecutionRecords){
      return Math.min(Math.floor((this.totalExecutionRecords/this.executionLimit) * 100), 100)
    }else{
      return 0
    }
  }

  getPercentage(): number {
    if(this.limit && this.totalRecords){
      return Math.min(Math.floor((this.totalRecords/this.limit) * 100), 100)
    }else{
      return 0
    }
  }

  getExecutionHistory(): void {
    const filter = {
      'sort': 'ASC',
      'sort_by': 'created_at',
      'page': 1,
      'limit': 1,
      'filter.is_active': true,
      'filter.start_date': moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
      'filter.end_date': moment().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
      'exclude_skipped_executions':true
    }

    this._dataCollectorService.getData(this._workflowService.apiUrls.workflows +'/execution_history', filter)
      .subscribe({
        next: (res: any) => {
          this.totalExecutionRecords = res?.total_records;
        },
        error: (err: any) => {
          if(err?.message){
            this._toast.error(err?.message);
          }
        }
      })
  }

  getActiveWorkflows(): void {
    const filter = {
      'sort': 'ASC',
      'sort_by': 'created_at',
      'page': 1,
      'limit': 1,
      'filter.is_active': true
    }

    this._dataCollectorService.getData(this._workflowService.apiUrls.workflows, filter)
      .subscribe({
        next: (res: any) => {
          this.totalRecords = res?.total_records;
        },
        error: (err: any) => {
          if(err?.message){
            this._toast.error(err?.message);
          }
        }
      })
  }
}
